export enum BankaHesabiSahibi {
    vekil = "vekil",
    muvekkil = "muvekkil",
}

export enum BankaHesabiSahibiLabel {
    vekil = "Vekil",
    muvekkil = "Müvekkil",
}
